module.exports = __webpack_public_path__ + "img/special_06.877139b8.png";